import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import {apiBaseUri} from '../config';
import { CognitoUser } from './cognito/CognitoUser';

const uri = apiBaseUri;

export const createClient = () => {
  const httpLink = createHttpLink({
    uri,
  });

  const authLink = setContext((_, { headers }) => {
    let session;

    try {
      session = new CognitoUser().getSession();
    } catch (e) {}
    //TODO: check this method. The header is not received
    return {
      headers: {
        ...headers,
        Authorization: session ? `Bearer ${session.accessToken.getJwtToken()}` : '',
        'x-app-id': "admin-app" 
      }
    };
  });

  const link = authLink.concat(httpLink);

  return new ApolloClient({
    link,
    cache: new InMemoryCache()
  })
};
